var render = function render(){var _vm=this,_c=_vm._self._c;return _c('simple-picker',{attrs:{"value":_vm.value,"placeholder-empty-state":_vm.placeholderEmptyState,"placeholder-search":_vm.placeholderSearch,"items":_vm.states,"item-label":"name","item-value":_vm.itemValue,"is-filterable":"","filterable-property":"name"},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }